import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f1e0e1ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-select" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id", "name", "value"]
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "filter__label",
          for: _ctx.id
        }, _toDisplayString(_ctx.label), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("select", {
      id: _ctx.id,
      name: _ctx.id,
      class: "form-control select-filter",
      value: _ctx.modelValue,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
        return (_openBlock(), _createElementBlock("option", {
          key: index,
          value: option.value
        }, _toDisplayString(option.label), 9, _hoisted_4))
      }), 128))
    ], 40, _hoisted_3)
  ]))
}